// src/config.ts

// Determine the base URL for API calls based on the environment
const getBaseUrl = (): string => {
    const env = process.env.NODE_ENV;
    
    // Use environment variables if available (preferred approach)
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL;
    }
  
    // Fallback values based on environment
    switch (env) {
      case 'production':
        return 'https://empower-future21-nodejs.vercel.app';
      
      case 'development':
      default:
        return 'http://localhost:3001';
    }
  };
  
  // Export configuration values
  export const API_BASE_URL = getBaseUrl();
  
  // You can add other configuration values here
  export const TOKEN_STORAGE_KEY = 'token';
  export const USER_STORAGE_KEY = 'user';